(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        this.onScroll();
      });

      observer.observe(this.header);
      
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Selected-Comments"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".article-carousel");
  if (!carousel) return;

  const track = carousel.querySelector(".article-carousel-track");
  let slides = carousel.querySelectorAll(".article-carousel-slide");
  const dotsContainer = carousel.querySelector(".article-carousel-dots");
  let currentSlide = 0;

  const firstSlideClone = slides[0].cloneNode(true);
  const lastSlideClone = slides[slides.length - 1].cloneNode(true);
  track.appendChild(firstSlideClone);
  track.insertBefore(lastSlideClone, slides[0]);
  slides = carousel.querySelectorAll(".article-carousel-slide");

  currentSlide = 1;
  track.style.transition = 'none';
  track.style.transform = `translateX(-${currentSlide * 100}%)`;
  void track.offsetWidth; // 强制重绘
  track.style.transition = 'transform 0.5s ease';

  for (let i = 0; i < slides.length - 2; i++) {
    const dot = document.createElement("button");
    if (i === 0) dot.classList.add("active");
    dot.setAttribute("aria-label", `第 ${i + 1} 张幻灯片`);
    dot.addEventListener("click", () => {
      currentSlide = i + 1;
      updateSlide();
    });
    dotsContainer.appendChild(dot);
  }

  const lazyImages = document.querySelectorAll('.lazy-image');
  if ('IntersectionObserver' in window) {
    const lazyLoadObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.add('loaded');
          lazyLoadObserver.unobserve(img);
        }
      });
    }, {
      rootMargin: '500px 0px',
      threshold: 0.01
    });
    lazyImages.forEach(img => lazyLoadObserver.observe(img));
  } else {
    lazyImages.forEach(img => {
      img.src = img.dataset.src;
      img.classList.add('loaded');
    });
  }

  function preloadAdjacentSlides() {
    const realIndex = currentSlide - 1;
    [realIndex - 1, realIndex, realIndex + 1].forEach(index => {
      if (index >= 0 && index < slides.length - 2) {
        const slide = slides[index + 1];
        slide.querySelectorAll('.lazy-image:not(.loaded)')
          .forEach(img => {
            img.src = img.dataset.src;
            img.classList.add('loaded');
          });
      }
    });
  }

  function updateSlide() {
    track.style.transform = `translateX(-${currentSlide * 100}%)`;
    const dots = dotsContainer.querySelectorAll("button");
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === currentSlide - 1);
    });
    preloadAdjacentSlides();
  }

  function nextSlide() {
    currentSlide++;
    track.style.transition = 'transform 0.5s ease';
    updateSlide();
    if (currentSlide === slides.length - 1) {
      setTimeout(() => {
        track.style.transition = 'none';
        currentSlide = 1;
        updateSlide();
        void track.offsetWidth;
        track.style.transition = 'transform 0.5s ease';
      }, 500);
    }
  }

  function prevSlide() {
    currentSlide--;
    track.style.transition = 'transform 0.5s ease';
    updateSlide();
    if (currentSlide === 0) {
      setTimeout(() => {
        track.style.transition = 'none';
        currentSlide = slides.length - 2;
        updateSlide();
        void track.offsetWidth;
        track.style.transition = 'transform 0.5s ease';
      }, 500);
    }
  }

  // 点击按钮切换
  if (slides.length > 3) {
    const prevButton = carousel.querySelector(".article-carousel-prev");
    const nextButton = carousel.querySelector(".article-carousel-next");
    prevButton.addEventListener("click", prevSlide);
    nextButton.addEventListener("click", nextSlide);
  }

  if ('ontouchstart' in window) {
    let startX = 0, startY = 0, isScrolling = false, threshold = 50;
    carousel.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isScrolling = undefined;
    });
    carousel.addEventListener('touchmove', function(e) {
      if (typeof isScrolling === 'undefined') {
        const diffX = Math.abs(e.touches[0].clientX - startX);
        const diffY = Math.abs(e.touches[0].clientY - startY);
        isScrolling = diffY > diffX;
      }
      if (!isScrolling) e.preventDefault();
    });
    carousel.addEventListener('touchend', function(e) {
      if (isScrolling) return;
      const endX = e.changedTouches[0].clientX;
      const distance = endX - startX;
      if (distance > threshold) prevSlide();
      else if (distance < -threshold) nextSlide();
    });
  }

  if (!('ontouchstart' in window)) {
    let isDragging = false, startX = 0, dragThreshold = 50;
    carousel.addEventListener('mousedown', function(e) {
      e.preventDefault();
      isDragging = true;
      startX = e.clientX;
      carousel.classList.add('dragging');
      track.style.transition = 'none';
    });
    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      const deltaX = e.clientX - startX;
      track.style.transform = `translateX(${-currentSlide * 100 + (deltaX / carousel.clientWidth) * 100}%)`;
    });
    document.addEventListener('mouseup', function(e) {
      if (!isDragging) return;
      isDragging = false;
      carousel.classList.remove('dragging');
      const deltaX = e.clientX - startX;
      track.style.transition = 'transform 0.5s ease';
      if (deltaX > dragThreshold) prevSlide();
      else if (deltaX < -dragThreshold) nextSlide();
      else updateSlide();
    });
  }

  preloadAdjacentSlides();
});


  } catch(e) { console.error(e); }
})();
})();
